import { required as vuelidateRequire, helpers } from '@vuelidate/validators'

import { Maybe } from 'shared/graphql_types'

export const errorsFor = validatedModel => {
  if (
    validatedModel &&
    validatedModel.$dirty &&
    validatedModel.$error
  ) {
    return {
      errors: validatedModel.$errors.map((error) => error.$message),
      errored: true
    }
  } else {
    return {
      errors: [],
      errored: false
    }
  }
}

// From https://regexr.com/6o0cf
export const emailAddressRegex = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,}$/
// No special characters except hyphens, underscores, and quotes
export const noSpecialCharRegex = /^["”’\-,'_.a-zA-Z0-9À-ÿğłŞşőı\s]*$/

export const isValidEmail = (field: string) => {
  return helpers.withMessage(
    `${field} must be a valid email address`,
    (value: Maybe<string>) => value === null || value === '' || emailAddressRegex.test(value)
  )
}

export const positiveInteger = (field: string, options = { allowZero: false }) => {
  return helpers.withMessage(
    `${field} must be a positive integer`,
    (value: Maybe<string | number>) =>
      value === null ||
      value === '' ||
      (Number.isInteger(Number(value)) && (options.allowZero ? value >= 0 : value > 0))
  )
}

export const cannotContainSpecialCharacters = (field: string) => {
  return helpers.withMessage(
    `${field} contains illegal characters`,
    (value: string | null) => value === null || noSpecialCharRegex.test(value)
  )
}

export const required = (field: string, errorMessage = `${field} is required`) => {
  return helpers.withMessage(errorMessage, vuelidateRequire)
}

export const atLeastOne = function <T> (field: string) {
  return helpers.withMessage(
    `${field} requires at least one entry`,
    (value: T[]) => value && value.length > 0
  )
}
